import { useEffect, useState } from "react";
import GenelDurumHelper from "../../../../helpers/GenelDurumHelper";
import CsmIcerikHelper from "../../../../library/helpers/CsmIcerikHelper";

interface IUsePdfPageImagesParams {
    icerikId: string,
    genelDurumHelper: GenelDurumHelper,
    onIcerikIdChange: () => void,
}

export function usePdfPageImages(params: IUsePdfPageImagesParams) {
    const [imageUrlList, setImageUrlList] = useState<{ uri: string }[] | null>(null);

    const fetchPdfImages = async () => {
        const webResponse = await params.genelDurumHelper.requestHelper.Genel.IcerikGetirPDF(params.icerikId);
        if (!webResponse.successfull) {
            setImageUrlList(null);
            return;
        }

        const data = webResponse.data!
            .select(e => CsmIcerikHelper.GetImageSourceFromBase64Content(e.icerik)!)
            .where(e => e !== null);
        setImageUrlList(data);
    };

    useEffect(() => {
        params.onIcerikIdChange();
        setImageUrlList(null);
        fetchPdfImages();
    }, [params.icerikId]);

    return { imageUrlList };
}
